import { render, staticRenderFns } from "./relatorio-atendimentos-quantitativo.vue?vue&type=template&id=1ec764ab"
import script from "./relatorio-atendimentos-quantitativo.vue?vue&type=script&lang=js"
export * from "./relatorio-atendimentos-quantitativo.vue?vue&type=script&lang=js"
import style0 from "./relatorio-atendimentos-quantitativo.vue?vue&type=style&index=0&id=1ec764ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports